/* eslint-disable semi,semi-style */
import { env, host } from './env';

// let logoutUrl
// let loginUrl
const setCookiePath = '/open-platform-web/api/index/setCookie';
let passport;
const query = () =>
  '?appid=121997&source=121997&role=423&redirectUrl=' +
  // '?appid=40015&source=40015&role=423&redirectUrl=' +
  encodeURIComponent(`${host + setCookiePath}?url=${location.origin}/#/`);
if (env === 'online') {
  passport = 'https://passport.didichuxing.com/common/pc-login/2.0.0/index.html';
} else if (env === 'pre') {
  passport = 'https://passport.didichuxing.com/common/pc-login/2.0.0/index.html';
} else {
  passport = 'http://passport-test.didichuxing.com/static/pc-login/2.0.0/index.html';
}
export const login = () => `${passport}${query()}`;
export const logout = () => `${passport}${query()}#/logout`;

// passport = 'https://passport.didichuxing.com/common/pc-login/1.1.0/index.html'
